import { CamelizedBundleVariants } from 'src/queries/__generated__/wweBundle';
import { calculateAvailableImages } from 'src/components/BundleProduct/utils/MediaCalculationTools';

const createMediaEntry = (url: string) => ({
    position: 0,
    media_type: 'image',
    label: 'unknown',
    large_height: 720,
    large_width: 720,
    large_url: url,
    medium_url: url,
    small_url: url,
});

export const getCalculatedMediaEntries = (colorId: number, colorVariants?: CamelizedBundleVariants) => {
    const availableColorsImages = calculateAvailableImages(colorVariants);
    const url = availableColorsImages.find((image) => image.color === colorId)?.image;

    return url ? createMediaEntry(url) : undefined;
};
